export enum CreditType {
  none,
  stats,
  bonus,
}
